var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPods = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7612 13.2051C14.7008 13.3326 14.8554 13.4555 14.9491 13.35C16.9715 11.0747 16.9715 7.38572 14.9491 5.11043C12.9268 2.83514 9.6479 2.83514 7.62555 5.11043C7.53004 5.21788 7.67782 5.36659 7.80193 5.29404C9.75282 4.15359 12.2136 4.50437 13.8508 6.34637C15.5013 8.20331 15.8048 11.0019 14.7612 13.2051Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64093 9.90654C7.70359 9.78753 7.56011 9.65998 7.46501 9.7551C5.44265 11.7776 5.44265 15.0567 7.46501 17.0792C9.48736 19.1016 12.7662 19.1016 14.7886 17.0792C14.8838 16.9839 14.7561 16.8403 14.6369 16.903C12.6821 17.9323 10.2075 17.6248 8.56334 15.9805C6.91918 14.3363 6.61171 11.8614 7.64093 9.90654Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1131 14.5661C9.99408 14.5034 9.86654 14.6469 9.96165 14.742C11.9841 16.7644 15.2632 16.7644 17.2857 14.742C19.3082 12.7197 19.3082 9.44078 17.2857 7.41842C17.1905 7.3232 17.0468 7.45093 17.1096 7.5701C18.1388 9.52488 17.8314 11.9995 16.1871 13.6437C14.5428 15.2878 12.068 15.5953 10.1131 14.5661Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2755 7.63095C12.3995 7.7034 12.547 7.55487 12.4516 7.44756C10.4292 5.17241 7.15006 5.17241 5.12758 7.44756C3.1051 9.7227 3.1051 13.4114 5.12758 15.6866C5.22146 15.7922 5.3762 15.6691 5.31571 15.5415C4.27209 13.3384 4.57558 10.54 6.22619 8.68318C7.86355 6.84128 10.3245 6.49053 12.2755 7.63095Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPods);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pods.71ef0a5995571d515336a581b57fa971.svg";